import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";

const IMG_PATH = process.env.REACT_APP_IMAGE_BASEURL || "";

const PastPresident = () => {
  const [loading, setLoading] = useState(false);
  const [pastpresidents, setPastPresidents] = useState([]);

  useEffect(() => {
    const fetchPastPresidents = async () => {
      setLoading(true);
      try {
        const response = await API.get(
          api_paths.member.PAST_PRESIDENTS.GET_LIST
        );
        // console.log("past president List:", response.data);

        const data = response.data?.payload?.data || [];
        setPastPresidents(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPastPresidents();
  }, []);

  return (
    <Container className="py-5">
      <Row className="mb-4">
        <Col lg={12}>
          <div className="rsvp-header text-center">
            <h1 className="inter-bold h1">Past Presidents</h1>
            <p>Honoring the leaders who shaped our community</p>
          </div>
        </Col>
      </Row>

      <Row>
        {pastpresidents.map((president) => (
          <Col key={president._id} lg={4} md={6} sm={12} className="mb-4">
            <Card className="h-100 shadow-sm">
              <Card.Img
                variant="top"
                src={`${IMG_PATH}${president?.picture_path}`}
                className="card-img-fixed"
              />

              <Card.Body>
                <Card.Title className="fw-bold">{president.name}</Card.Title>

                <div className="text-muted mb-2">
                  {president?.start_year}
                  {president?.end_year && <>- {president?.end_year}</>}
                </div>

                <Card.Text>{president?.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default PastPresident;
